exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".option[data-v-766cfbf8] {\n  display: inline-block;\n}\n.option[data-v-766cfbf8]:not(:first-child) {\n    padding-left: 10px;\n}\n", ""]);

